import {DragIndicator} from '@material-ui/icons';
import React from 'react';

export function DragIndicatorIcon() {
  return <DragIndicator fontSize="small" color="disabled" />;
}
